const SplitStep = () => {
  return null;
};

export default SplitStep;
